export const actions = {
  CACHE_ELIMINAR_CATEGORIA_REQUESTED: 'CACHE_ELIMINAR_CATEGORIA_REQUESTED',
  CACHE_ELIMINAR_CATEGORIA_SUCCEEDED: 'CACHE_ELIMINAR_CATEGORIA_SUCCEEDED',
  CACHE_ELIMINAR_CATEGORIA_FILED: 'CACHE_ELIMINAR_CATEGORIA_FILED',

  CACHE_ELIMINAR_ETIQUETA_REQUESTED: 'CACHE_ELIMINAR_ETIQUETA_REQUESTED',
  CACHE_ELIMINAR_ETIQUETA_SUCCEEDED: 'CACHE_ELIMINAR_ETIQUETA_SUCCEEDED',
  CACHE_ELIMINAR_ETIQUETA_FILED: 'CACHE_ELIMINAR_ETIQUETA_FILED',
}

export const removeCacheCategoriaAction = dispatch => {
  dispatch({
    type: actions.CACHE_ELIMINAR_CATEGORIA_REQUESTED,
  })
}

export const removeCacheEtiquetaAction = dispatch => {
  dispatch({
    type: actions.CACHE_ELIMINAR_ETIQUETA_REQUESTED,
  })
}
